module.exports = __webpack_public_path__ + "static/media/ThumbnailStill08.ce6f446a.png";